import React from 'react';
import teamData from '../data/data';
import Card from './Card';

const Cards = () => (
  <div className="grid font-montserrat grid-cols-2 mx-6 md:grid-cols-3 md:mr-6 md:mx-10 lg:mx-24 lg:mr-52 2xl:mr-24 2xl:grid-cols-4 2xl:mx-42 3xl:mr-24 3xl:grid-cols-5 3xl:mx-43">
    {teamData.map((data, index) => (
      <Card data={data} key={index} />
    ))}
  </div>
);

export default Cards;
